<template>
    <div v-if="user">
        <va-page-header class="words_header" style="    display: flex;
        justify-content: space-between;">
            <div slot="title">
                <span>{{ _('Language Data') }}</span>
            </div>

            <div slot="actions">
                <div style="display: flex; align-items: center">
                    <va-input style="margin-right: 10px" @change="search(1)" v-model="searchString"
                        :placeholder="_('Search')" icon="search" showClean></va-input>
                    <va-button v-if="user.get('roles').includes('admin')" size="lg" type="primary"
                        @click.native="navigate('/words/new')">{{ _('NEW DATA') }}
                    </va-button>

                </div>
            </div>

        </va-page-header>

        <div v-if="allWordsCount !== 0">
            <va-row :gutter="12">
                <va-column :lg="12" :sm="12">
                    <va-table hover fullWidth class="datatable">
                        <table :dir="getDirectionStatus">
                            <thead>
                                <tr>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        English
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        پښتو
                                    </th>
                                    <th :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true}">
                                        دری
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="word in perPageWords">
                                    <td style="max-width: 200px"
                                        :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true, fixed_td: true}">
                                        <a style="cursor:pointer"
                                            @click="navigate('/words/' + word.id)">{{word.get('english')}}</a></td>
                                    <td style="max-width: 200px"
                                        :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true, fixed_td: true}">
                                        {{ word.get('pashto') }}
                                    </td>
                                    <td style="max-width: 200px"
                                        :class="{rtlTableHead: getSystemLanguage != 'english', smallTd: true, fixed_td: true}">
                                        {{ word.get('dari') }}
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </va-table>

                </va-column>
            </va-row>
            <va-row :gutter="12">
                <va-column :lg="6" :sm="6">
                    <div style="display: flex">
                        <v-page :class="{no_click: allWordsCount==0}" :key="$route.path" :total-row="allWordsCount"
                            @page-change="paginate"></v-page>

                        <va-button style="margin-left: 10px" @click.native="paginate({PageNumber: page})">
                            <va-icon type="sync-alt"></va-icon>
                        </va-button>
                    </div>
                </va-column>
            </va-row>
        </div>
        <div v-else class="deadCenter">
            <p>{{ _('No word available') }}</p>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";

    export default {


        data() {
            return {
                page: 1,
                allWordsCount: null,
                perPageWords: [],
                searchString: ''
            }
        },


        computed: {
            ...mapGetters(["user", "getSystemLanguage", "getDirectionStatus"]),

        },


        methods: {

            async search(pageNumber) {
                if (this.searchString != '') {
                    var conditions = [];
                    let regex = new RegExp(`^.*${this.searchString}.*`, "i");
                    var temp = [];
                    temp.push(new Parse.Query('LanguageData').matches('english', regex))
                    temp.push(new Parse.Query('LanguageData').matches('pashto', regex))
                    temp.push(new Parse.Query('LanguageData').matches('dari', regex))

                    conditions.push(Parse.Query.or(...temp))

                    var mainQuery = Parse.Query.and(...conditions);

                    mainQuery.skip((pageNumber - 1) * 25)
                    mainQuery.limit(25)
                    mainQuery.descending('createdAt')
                    let results = await mainQuery.find();
                    this.perPageWords = results
                    this.allWordsCount = await mainQuery.count();
                } else {
                    this.fetchWords(1);
                    this.fetchWordsCount()
                }
            },



            async fetchWords(pageNumber) {
                let q = new Parse.Query('LanguageData')
                q.descending("createdAt");
                q.limit(1000)
                this.perPageWords = await q.find()
                this.$store.commit('setLoading', false)
            },

            async fetchWordsCount() {
                let q = new Parse.Query('LanguageData')
                this.allWordsCount = await q.count()
            },


            async paginate(page) {
                this.page = page.pageNumber
                if (this.searchString != '') {
                    // call search
                    this.search(page.pageNumber)
                } else {
                    this.$store.commit('setLoading', true)
                    await this.fetchWordsCount();
                    await this.fetchWords(page.pageNumber)
                }

            },

            navigate(to) {
                this.$router.push(to);
            },
        },


        async mounted() {
            this.$store.commit('setLoading', true)
            await this.fetchWordsCount();
            await this.fetchWords(1)

        }
    };
</script>

<style>
    .langs_table {
        position: relative;
    }

    .langs_table td {
        width: 33%;
        overflow: hidden !important;
        display: inline-block;
    }

    .langs_table td a {
        /* width: 13%; */
    }

    .words_header .va-page-header-title-wrapper {
        width: 100%;
    }
</style>